export class ProductPrice {
  Id?: number;
  ProductPriceId?: number;
  Origin?: string;
  Active?: boolean;
  Price?: number = 0.0;
  Discount?: number = 0.0;
  Points?: number = 0.0;
  ProductId?: number;
  CountryId?: number;
  CountryCode?: string;
  ShowAdjustments?: boolean;
  CreatedBy?: string;
  PriceCeiling?: number;
  AllowSetPrice?: boolean;
  CreatedDate?: string;
  UpdatedBy?: string;
  UpdatedDate?: string;
}
